(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.exclusive = this.dataset.exclusive === 'true';
        this.duration = 320;
        this.easing = 'cubic-bezier(0.2, 0.7, 0.2, 1)';

        // The browser would close the other items instantly; JS handles exclusivity instead.
        if (this.exclusive) {
          this.querySelectorAll('details[name]').forEach((item) => item.removeAttribute('name'));
        }

        this.onClick = (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !this.contains(summary)) return;
          const item = summary.parentElement;
          event.preventDefault();

          if (item.open && !item.classList.contains('is-closing')) {
            this.close(item);
          } else {
            this.open(item);
          }
        };

        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
      }

      items() {
        return Array.from(this.querySelectorAll('details'));
      }

      open(item) {
        if (this.exclusive) {
          this.items().forEach((other) => {
            if (other !== item && other.open && !other.classList.contains('is-closing')) this.close(other);
          });
        }

        const content = item.querySelector('.faqx__answer');
        const from = item.open ? content.getBoundingClientRect().height : 0;
        item.classList.remove('is-closing');
        item.open = true;
        const to = content.scrollHeight;
        this.animate(item, content, from, to);
      }

      close(item) {
        const content = item.querySelector('.faqx__answer');
        const from = content.getBoundingClientRect().height;
        item.classList.add('is-closing');
        this.animate(item, content, from, 0, () => {
          item.open = false;
          item.classList.remove('is-closing');
        });
      }

      animate(item, content, from, to, onDone) {
        if (item._faqAnimation) item._faqAnimation.cancel();

        content.style.overflow = 'hidden';
        const animation = content.animate(
          [
            { height: `${from}px`, opacity: from > 0 ? 1 : 0 },
            { height: `${to}px`, opacity: to > 0 ? 1 : 0 },
          ],
          { duration: this.duration, easing: this.easing }
        );
        item._faqAnimation = animation;

        animation.onfinish = () => {
          item._faqAnimation = null;
          content.style.overflow = '';
          if (onDone) onDone();
        };
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-bilingual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bilingual-testimonials')) {
    class BilingualTestimonials extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[ref="track"]');
        this.controls = this.querySelector('[ref="controls"]');
        this.counter = this.querySelector('[ref="counter"]');
        this.bar = this.querySelector('[ref="bar"]');
        this.prevBtn = this.querySelector('[ref="prev"]');
        this.nextBtn = this.querySelector('[ref="next"]');
        this.langButtons = this.querySelectorAll('[data-lang-btn]');

        this.onLangClick = (event) => this.setLang(event.currentTarget.dataset.langBtn);
        this.langButtons.forEach((btn) => btn.addEventListener('click', this.onLangClick));

        if (!this.track) return;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        this.prevBtn?.addEventListener('click', this.onPrev);
        this.nextBtn?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.langButtons?.forEach((btn) => btn.removeEventListener('click', this.onLangClick));
        this.prevBtn?.removeEventListener('click', this.onPrev);
        this.nextBtn?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      setLang(lang) {
        this.dataset.activeLang = lang;
        this.langButtons.forEach((btn) => {
          btn.setAttribute('aria-pressed', String(btn.dataset.langBtn === lang));
        });
        this.update();
      }

      metrics() {
        const cards = this.track.querySelectorAll('.bt__card');
        if (!cards.length) return { step: 0, pages: 1, count: 0 };
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = cards[0].getBoundingClientRect().width + gap;
        const style = getComputedStyle(this.track);
        const inner = this.track.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const visible = Math.max(1, Math.floor((inner + gap) / step));
        const pages = Math.max(1, cards.length - visible + 1);
        return { step, pages, count: cards.length };
      }

      go(direction) {
        const { step } = this.metrics();
        if (!step) return;
        this.track.scrollBy({ left: direction * step });
      }

      update() {
        const { step, pages } = this.metrics();
        if (!step) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        let index = Math.round(this.track.scrollLeft / step);
        if (this.track.scrollLeft >= maxScroll - 2) index = pages - 1;
        index = Math.min(Math.max(index, 0), pages - 1);

        if (this.controls) this.controls.hidden = pages <= 1;
        if (this.counter) this.counter.textContent = `${index + 1} / ${pages}`;
        if (this.bar) this.bar.style.width = `${((index + 1) / pages) * 100}%`;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }

    customElements.define('bilingual-testimonials', BilingualTestimonials);
  }

  } catch(e) { console.error(e); }
})();
})();
